import { Injectable } from '@angular/core';
import { Render } from '@App/app/entities/processing/render.model';
import { ApiService } from '@App/app/shared/api.service';
import { Observable } from 'rxjs';
import { NgHttpCachingHeaders } from 'ng-http-caching';

@Injectable({
  providedIn: 'root',
})
export class RendersHttpService extends ApiService {
  getRenders(modelId: number): Observable<Render[]> {
    return this.http.get<Render[]>(`${this.api}/models/${modelId}/renders`);
  }

  getExtendedRender(modelId: number, renderId: number): Observable<Render> {
    return this.http.get<Render>(`${this.api}/models/${modelId}/renders/${renderId}`, {
      headers: {
        [NgHttpCachingHeaders.ALLOW_CACHE]: '1',
      },
    });
  }

  getAnnotationsReport(modelId: number, renderId: number): Observable<unknown> {
    return this.http.get<unknown>(
      `${this.api}/models/${modelId}/renders/${renderId}/annotationsReport`,
    );
  }
}
